import React, { Component } from 'react';
import { sides } from '../../sections/auth/reducer'
import { connect } from 'react-redux'

class Header extends Component {

    openGoldie25 = () => {
        window.open('https://goldie25-app-prod-h8cth8f5hrdkg4h5.southeastasia-01.azurewebsites.net', '_blank', 'noopener,noreferrer');
    }

    onLogoutClick = () => {
        const { dispatch } = this.props
        dispatch(sides.logout())
    }

    render() {

        const styles = {
            appBar: {
                backgroundColor: "#a29064"
            },
            button: {
                background: "#a29064",
                color: "#fff",
                padding: "5px 10px",
                display: "inline - block",
                fontWeight: "bold",
                fontSize: "16px",
            },
            list: {
                paddingLeft: "20px"
            }
        }

        return (
            <div className="page-container">
                <header>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                <div className="logo">
                                    <a href="index.html">
                                        <img src="images/logo.png" alt="oceana" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-8 col-sm-8 col-xs-3 hidden-xs">
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12 hidden-xs">
                                <div className="brand_logo">
                                    <a href="">
                                        <img src="images/ipg-logo.png" alt="RED MARBLE" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12 hidden-xs">
                                <button style={styles.button} onClick={this.onLogoutClick}>Logout</button>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="banner_content_sec">
                    <img src="images/banner-image.jpg" alt="Banner Background" className="banner_img" />
                    <div className="banner_content">
                        <div className="container">
                            <div className="row display_flex">
                                <div className="col-md-9 col-sm-8 col-xs-12">
                                    <div className="hom_banner">
                                        <h3>Introducing Goldie</h3>
                                        <a href="https://oceanagold.sharepoint.com">Oceana Gold</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_content_sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10 col-sm-6">
                                <div className="middle_content" style={{ textAlign: "center" }}>
                                    <button style={styles.button} onClick={this.openGoldie25}>Chat with me!</button>
                                </div>
                                <img src="images/content_border.png" alt="Border" />
                                <div className="middle_content">
                                    <p>This is <strong>Goldie</strong>.</p>
                                    <p>Goldie is a natural language based chatbot that helps us to complete our daily tasks.</p>
                                    <p>You can say things like:</p>
                                    <p>
                                        <ul style={styles.list}>
                                            <li>"Approve Purchase Requisition 12345"</li>
                                            <li>"Close Work Order W568754"</li>
                                            <li>"I've completed my work order"</li>
                                            <li>"Do I have any PRs to approve?"</li>
                                            <li>"Check stock levels in the warehouse"</li>
                                        </ul>
                                    </p>
                                    <p>Goldie uses a type of Artificial Intelligence (AI) called Natural Language Processing to understand your intent from the text you enter. She will prompt you for any information needed and then answer your question or finish the task on your behalf.</p>
                                    <p>
                                        <ul style={styles.list}>
                                            <li>Currently running at Didipio since August 2018</li>
                                            <li>Reduction in time for closing a work order from 2 mins 30 seconds to 37 seconds</li>
                                            <li>Ability to display videos, images, documents and SharePoint links</li>
                                            <li>Addition of 11 new functions into Goldie and the user group has expanded to over 70 users</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* Added screenshot section */}
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="goldie25_screenshot" style={{ textAlign: "center", margin: "30px 0" }}>
                                    <img
                                        src="images/goldie25_screenshot.png"
                                        alt="Goldie 2.5 Screenshot"
                                        style={{ width: "80%", height: "auto", maxWidth: "100%" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 col-sm-8 more-info-text">
                                <h3 style={{ color: "#a29064" }}>For further information contact Gerard Hyland</h3>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default connect(state => state)(Header);
